import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { HeaderEnum } from "./constant";
const Products = (props) => {
    const [index, setIndex] = useState(0);
    const hidenavTab = () => {
        props.setShowNav(() => !props.showNav);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "mx-0 header-link-section" },
            React.createElement(Col, { lg: 12, className: "grid-5 gap-10" },
                React.createElement("ul", { className: "header-link-content" },
                    React.createElement("li", { className: "headermainheading" }, "Fixed Income"),
                    React.createElement("li", null,
                        React.createElement(Link, { to: HeaderEnum.FIXED_INCOME_CORPFD, onClick: () => {
                                hidenavTab();
                            } }, "Corp FD")),
                    React.createElement("li", null,
                        React.createElement(Link, { to: HeaderEnum.FIXED_INCOME_54ACBONDS, onClick: () => {
                                hidenavTab();
                            } }, "54EC Bonds"))),
                React.createElement("ul", { className: "header-link-content" },
                    React.createElement("li", { className: "headermainheading" }, "Alternatives"),
                    React.createElement("li", null,
                        React.createElement(Link, { to: HeaderEnum.ALTERNATIVE_SPMLD, onClick: () => {
                                hidenavTab();
                            } }, "SP/MLD")),
                    React.createElement("li", null,
                        React.createElement(Link, { to: HeaderEnum.ALTERNATIVE_SGB, onClick: () => {
                                hidenavTab();
                            } }, "SGB"))),
                React.createElement("ul", { className: "header-link-content" },
                    React.createElement("li", { className: "headermainheading" }, "Managed Portfolios"),
                    React.createElement("li", null,
                        React.createElement(Link, { to: HeaderEnum.MANGED_PORTFOLIO_MF, onClick: () => {
                                hidenavTab();
                            } }, "MF")),
                    React.createElement("li", null,
                        React.createElement(Link, { to: HeaderEnum.MANGED_PORTFOLIO_ETF, onClick: () => {
                                hidenavTab();
                            } }, "ETF")),
                    React.createElement("li", null,
                        React.createElement(Link, { to: HeaderEnum.MANGED_PORTFOLIO_SMALLCASE, onClick: () => {
                                hidenavTab();
                            } }, "SmallCase")),
                    React.createElement("li", null,
                        React.createElement(Link, { to: HeaderEnum.MANGED_PORTFOLIO_PICKRIGHT, onClick: () => {
                                hidenavTab();
                            } }, "Pickright"))),
                React.createElement("ul", { className: "header-link-content" },
                    React.createElement("li", { className: "headermainheading" }, "Secondary Markets"),
                    React.createElement("li", null,
                        React.createElement(Link, { to: HeaderEnum.SEC_MARKET_EQUITY, onClick: () => {
                                hidenavTab();
                            } }, "Equity")),
                    React.createElement("li", null,
                        React.createElement(Link, { to: HeaderEnum.COMMODITY, onClick: () => {
                                hidenavTab();
                            } }, "Commodity")),
                    React.createElement("li", null,
                        React.createElement(Link, { to: HeaderEnum.SEC_MARKET_CURRENCY, onClick: () => {
                                hidenavTab();
                            } }, "Currency"))),
                React.createElement("ul", { className: "header-link-content" },
                    React.createElement("li", { className: "headermainheading" }, "Insurance"),
                    React.createElement("li", null,
                        React.createElement(Link, { to: HeaderEnum.INSURANCE_GENERAL, onClick: () => {
                                hidenavTab();
                            } }, "General Insurance")),
                    React.createElement("li", null,
                        React.createElement(Link, { to: HeaderEnum.INSURANCE_LIFE, onClick: () => {
                                hidenavTab();
                            } }, "Life Insurance")))))));
};
export default Products;
